<header class="flex items-center justify-between h-16 px-6 bg-white border-b border-gray-200 flex-shrink-0">
  <div class="flex items-center">
    <!-- Mobile Menu Button -->
    <button (click)="toggleMobileMenu.emit()" class="text-gray-500 focus:outline-none lg:hidden mr-4">
      <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 6H20M4 12H20M4 18H11" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>

    <div class="flex gap-2">
      <span class="w-1.5 h-6 bg-indigo-600 rounded-full"></span>
      <h2 class="hidden lg:block fs-16 font-semibold">{{ titleKey() | translate }}</h2>
    </div>
  </div>
  <div class="flex items-center space-x-4">
    <div *ngIf="isAdminLogin">
      <button (click)="getStore()"
        class="flex items-center px-3 py-1 border rounded-md text-sm text-gray-600 hover:bg-gray-100">
        {{strNm}}
      </button>
    </div>

    <div class="relative" #langWrapper>
      <button (click)="langDropdownOpen.set(!langDropdownOpen())"
        class="flex items-center px-3 py-1 border rounded-md text-sm text-gray-600 hover:bg-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9V3" />
        </svg>
        @if(currentLang == 'en') {<span>{{'SYSMESER0017' | translate}}</span>}
        @if(currentLang == 'ko') {<span>{{'SYSMESER0018' | translate}}</span>}
        @if(currentLang == 'vi') {<span>{{'SYSMESER0016' | translate}}</span>}
      </button>
      @if (langDropdownOpen()) {
      <div class="absolute right-0 mt-2 w-44 bg-white rounded-md shadow-lg z-40 border border-gray-200">
        <a (click)="setLanguage('ko')"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">{{'SYSMESER0018' |
          translate}}</a>
        <a (click)="setLanguage('en')"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">{{'SYSMESER0017' |
          translate}}</a>
        <a (click)="setLanguage('vi')"
          class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">{{'SYSMESER0016' |
          translate}}</a>
      </div>
      }
    </div>
    <div class="flex items-center">
      <span class="relative flex h-3 w-3">
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
        <span class="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
      </span>
      <!-- <span class="ml-2 text-sm text-green-600 font-semibold">{{ 'header.systemOnline' | translate }}</span> -->
    </div>
    <div class="text-right cursor-pointer" (click)="toggle($event)">
      <p class="text-sm font-semibold text-gray-800">{{ userName }}</p>
      <p class="text-xs text-gray-500">{{today}}</p>
    </div>
    <p-popover #op>
      <div>
        <button (click)="visible = true" class="w-full flex gap-2 bg-gray-600 text-white rounded-md p-2">
          <i class="pi pi-key flex items-center" pButtonIcon></i>
          <span pButtonLabel>{{'SYSMESER0012' | translate}}</span>
        </button>
      </div>
    </p-popover>
  </div>
</header>

<p-dialog [header]="'STOREHQ0047' | translate" [modal]="true" [(visible)]="showStore"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="false">
  <div *ngIf="showStore">
    <div class="flex flex-col gap-3">
      <div class="grid grid-cols-12 gap-3">
        <div class="col-span-10">
          <input pInputText type="text" [(ngModel)]="param.P_STR_NM" [placeholder]="'STOREHQ0048' | translate"
            (keydown.enter)="getStore()" class="w-full" maxlength="50">
        </div>
        <div class="col-span-2">
          <button (click)="getStore()"
            class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white fs-14 rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-full">{{'PAYMESTR0046'
            | translate}}</button>
        </div>
      </div>
      <p-table #tb [value]="stores" dataKey="stR_CD" showGridlines paginator="true" [rows]="P_PAGEROW"
        [totalRecords]="totalCnt" [lazy]="true" (onLazyLoad)="loadPage($event)">
        <ng-template #header>
          <tr>
            <th class="w-[20%]">{{'STOREHQ0005' | translate}}</th>
            <th class="w-[50%]">{{'STOREHQ0006' | translate}}</th>
            <th class="w-[30%]">{{'STOREHQ0007' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template #body let-store>
          <tr class="cursor-pointer" (click)="selectStore(store)">
            <td class="text-left">{{ store.stR_CD }}</td>
            <td class="text-left">{{ store.stR_NM }}</td>
            <td class="text-left">{{ store.stR_STAT_NM }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="100%" style="text-align: center;">
              {{'SYSMESER0004' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>

<p-dialog [header]="'LOGINHQ0031' | translate" [modal]="true" [(visible)]="visible" (visibleChange)="resetForm()"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="false">
  <form [formGroup]="useForm" (submit)="changePass()">
    <input type="text" autocomplete="username" name="username" hidden />
    <div>
      <label
        class="block text-surface-900 dark:text-surface-0 font-medium text-xl mb-2 fs-14 fw-500 clr-gray">{{'LOGINHQ0033'
        | translate}}</label>
      <p-password [toggleMask]="true" formControlName="CurrentPassword" autocomplete="current-password1"
        styleClass="fs-18 fw-500 clr-black" [placeholder]="'LOGINHQ0046' | translate" [fluid]="true" [feedback]="false"
        [maxLength]="30"
        [ngClass]="{ 'ng-invalid ng-dirty': useForm.get('CurrentPassword')?.invalid && useForm.get('CurrentPassword')?.touched}"></p-password>
      <p *ngIf="useForm.get('CurrentPassword')?.invalid && useForm.get('CurrentPassword')?.touched" class="text-red-500">
        {{'LOGINHQ0028' | translate}}
      </p>
    </div>

    <div class="mt-4">
      <label
        class="block text-surface-900 dark:text-surface-0 font-medium text-xl mb-2 fs-14 fw-500 clr-gray">{{'LOGINHQ0034'
        | translate}}</label>
      <p-password [toggleMask]="true" formControlName="Password" autocomplete="new-password"
        styleClass="fs-18 fw-500 clr-black" [fluid]="true" [feedback]="false" [placeholder]="'LOGINHQ0024' | translate"
        [maxLength]="30"
        [ngClass]="{ 'ng-invalid ng-dirty': useForm.get('Password')?.invalid && useForm.get('Password')?.touched}"></p-password>
      <p *ngIf="useForm.get('Password')?.invalid && useForm.get('Password')?.touched" class="text-red-500">
        {{'LOGINHQ0028' | translate}}
      </p>
    </div>

    <div class="mt-3">
      <label class="block text-surface-900 dark:text-surface-0 font-medium text-xl mb-2 fs-14 fw-500 clr-gray"></label>
      <p-password formControlName="ConfirmPassword" [toggleMask]="true" [placeholder]="'LOGINHQ0025' | translate"
        styleClass="fs-18 fw-500 clr-black" [fluid]="true" [feedback]="false" [maxLength]="30"
        autocomplete="confirm-password"
        [ngClass]="{ 'ng-invalid ng-dirty': useForm.get('ConfirmPassword')?.hasError('passwordMismatch') && useForm.get('ConfirmPassword')?.touched}"></p-password>
      <p *ngIf="useForm.get('ConfirmPassword')?.hasError('passwordMismatch') && useForm.get('ConfirmPassword')?.touched"
        class="text-red-500">
        {{'LOGINHQ0029' | translate}}
      </p>
    </div>

    <div class="flex justify-center mt-5">
      <button type="submit" class="flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-1/2">{{'LOGINHQ0031' |
        translate}}</button>
    </div>
  </form>
</p-dialog>

<app-pop-up-common [showConfirm]="showConfirmLogin" (confirmEvent)="logout()" [showCancel]="false" [title]="'SYSMESER0021'" [btnText]="'LOGINHQ0006'"
    [message]="'SYSMESER0020'"></app-pop-up-common>